/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiCalcOverridePreferenceFromJSON, ApiCalcOverridePreferenceToJSON, } from './ApiCalcOverridePreference';
import { ApiClassificationGroupFromJSON, ApiClassificationGroupToJSON, } from './ApiClassificationGroup';
import { ApiClassificationItemFromJSON, ApiClassificationItemToJSON, } from './ApiClassificationItem';
import { ApiProjectFromJSON, ApiProjectToJSON, } from './ApiProject';
import { ApiStatusFromJSON, ApiStatusToJSON, } from './ApiStatus';
export function ApiClassificationFromJSON(json) {
    return ApiClassificationFromJSONTyped(json, false);
}
export function ApiClassificationFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'alias': !exists(json, 'alias') ? undefined : json['alias'],
        'calcOverridePrefernce': !exists(json, 'calcOverridePrefernce') ? undefined : ApiCalcOverridePreferenceFromJSON(json['calcOverridePrefernce']),
        'classificationGroupId': !exists(json, 'classificationGroupId') ? undefined : json['classificationGroupId'],
        'classificationItems': !exists(json, 'classificationItems') ? undefined : (json['classificationItems'].map(ApiClassificationItemFromJSON)),
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'deletedAt': !exists(json, 'deletedAt') ? undefined : (new Date(json['deletedAt'])),
        'description': !exists(json, 'description') ? undefined : json['description'],
        'googleCustomDimensionId': !exists(json, 'googleCustomDimensionId') ? undefined : json['googleCustomDimensionId'],
        'googleId': !exists(json, 'googleId') ? undefined : json['googleId'],
        'group': !exists(json, 'group') ? undefined : ApiClassificationGroupFromJSON(json['group']),
        'id': !exists(json, 'id') ? undefined : json['id'],
        'key': !exists(json, 'key') ? undefined : json['key'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'project': !exists(json, 'project') ? undefined : ApiProjectFromJSON(json['project']),
        'projectId': !exists(json, 'projectId') ? undefined : json['projectId'],
        'pushedToGoogleAnalytics': !exists(json, 'pushedToGoogleAnalytics') ? undefined : json['pushedToGoogleAnalytics'],
        'status': !exists(json, 'status') ? undefined : ApiStatusFromJSON(json['status']),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
    };
}
export function ApiClassificationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'alias': value.alias,
        'calcOverridePrefernce': ApiCalcOverridePreferenceToJSON(value.calcOverridePrefernce),
        'classificationGroupId': value.classificationGroupId,
        'classificationItems': value.classificationItems === undefined ? undefined : (value.classificationItems.map(ApiClassificationItemToJSON)),
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'deletedAt': value.deletedAt === undefined ? undefined : (value.deletedAt.toISOString()),
        'description': value.description,
        'googleCustomDimensionId': value.googleCustomDimensionId,
        'googleId': value.googleId,
        'group': ApiClassificationGroupToJSON(value.group),
        'id': value.id,
        'key': value.key,
        'name': value.name,
        'project': ApiProjectToJSON(value.project),
        'projectId': value.projectId,
        'pushedToGoogleAnalytics': value.pushedToGoogleAnalytics,
        'status': ApiStatusToJSON(value.status),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
    };
}
